export default {"src":"/_next/static/media/whatapps-icon.20c5e9d0.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};